import { useState, useRef,useMemo  } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";

const OnBoarding = ({ company_id }) => {
  const user_id = company_id;

  const BaseUrl = process.env.REACT_APP_API;

  const employeeMap = {
    1: "Less Than 10 Employees",
    2: "11-25 Employees",
    3: "26-50 Employees",
    4: "51-99 Employees",
    5: "100-500 Employees",
    6: "Above 500 Employees",
  };
  const turnoverMap = {
    1: "Less than 50",
    2: "51-99",
    3: "100-250",
    4: "251-500",
    5: "501-1,000",
    6: "Above 1,000",
  };
  const typeOfProfile = {
    1: "Resident",
    2: "Non- resident",
  };
  const typeOfAccount = {
    1: "Individual",
    2: "Entity",
  };
  const natureOfAccount = {
    1:"Investment in Equities",
    2:"Investment in Securities",
    3:"Investment in Bonds",
    4:"Investment in Commodities",
    5:"Investment in Mutual Funds",
    6:"Investment in Stocks",
    7:"Investment in Digital Assets"
  };
  const anticipateVolume = {
    1:"1 - 100,000 USD",
    2:"100,000 - 500,000 USD",
    3:"500,000 - 1,000,000 USD",
    4:"1,000,000 - 10,000,000 USD",
    5:"10,000,000 - 50,000,000 USD"
  };
  const sourceOfFunds = {
    1:"Salary",
    2:"Business Activity",
    3:"Savings",
    4:"Pension",
    5:"Inheritance",
    6:"Gift",
    7:"Bonus",
    8:"Indemnity/End of Service Payment",
    9:"Return on Investments",
    10:"Other",
  };
  const downloadLinkRef = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [countries, setCountry] = useState([]);
  const [signatureURL, setSignatureURL] = useState('');



  const formatDateToIST = (dateString) => {
    if (!dateString) return '';
  
    const date = new Date(dateString);
    
    const istOffset = 5.5 * 60 * 60 * 1000; 
    const localDate = new Date(date.getTime() + istOffset);
  
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  };
  const declarationDate = useMemo(() => formatDateToIST(companyData[0]?.declaration_date), [companyData]);


  useEffect(() => {
    const fetchSignature = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/digital-signature/${companyData[0]?.digital_signature}`, {
          responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = URL.createObjectURL(blob);
        setSignatureURL(url);
      } catch (error) {
        console.error('Error fetching digital signature:', error);
      }
    };

    if (companyData[0]?.digital_signature) {
      fetchSignature();
    }
  }, [companyData[0]?.digital_signature]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${BaseUrl}/countries`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCountry(data);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };
    fetchCountries();
  }, [BaseUrl]);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true);

        const response = await axios.post(`${BaseUrl}/getCompanyInfoAdmin`, {
          user_id,
        });

        setLoading(false);
        setCompanyData(response.data);
      } catch (error) {
        console.log(error.message || "Error fetching company data");
      }
    };

    fetchCompanyData();
  }, [BaseUrl, user_id]);





  const [isReadOnly, setReadOnly] = useState(false);
  

  const handleDownload = async (filename) => {
    const response = await fetch(`${BaseUrl}/download/${filename}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      toast.success("File downloaded successfully.");

      // Create a temporary anchor element to trigger the download
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      // Ensure downloadLinkRef.current is not null before accessing its properties
      if (downloadLinkRef.current) {
        downloadLinkRef.current.href = url;
        downloadLinkRef.current.setAttribute("download", filename);
        downloadLinkRef.current.click();
      } else {
        console.error("downloadLinkRef.current is null");
      }
    } else {
      return;
    }
  };

  const getCountryName = (numCode) => {
    const country = countries?.find(
      (country) => country.NumCode && country.NumCode.toString() === numCode
    );
    return country ? country.Country : "Select";
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
   
      <div className="page-content">
        <div className="container-fluid">
          <div id="message"></div>
          <div id="printableArea">
          <div id="completeform">
            <form id="mform">
              
              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="card">
                    {/* Add the Print button here */}
                    <div className="d-flex justify-content-between">
                            
              </div>
                    <div className="card-header">
                      <h4
                        className="card-title fw-bold"
                        style={{ color: "#776ad8" }}
                      >
                        Company Info
                      </h4>
                    </div>
                    <div className="card-body">
                      <Table striped bordered hover>
                        <tbody>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Name of the Institution:
                            </th>
                            <td>{companyData[0]?.name_of_institution}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Company Legal Status:
                            </th>
                            <td>{companyData[0]?.legal_status}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Country of Incorporation:
                            </th>
                            <td>
                              {getCountryName(
                                companyData[0]?.country_of_incorporation
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Company Registration Number:
                            </th>
                            <td>{companyData[0]?.registration_number}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Date of Incorporation:
                            </th>
                            <td>{companyData[0]?.incorporation_date}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Registering Authority:
                            </th>
                            <td>{companyData[0]?.registering_authority}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Business Activity:
                            </th>
                            <td>{companyData[0]?.business_activity}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Annual Turnover (US$ Millions):
                            </th>
                            <td>
                              {turnoverMap[companyData[0]?.annual_turnover]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                             Type of Profile:
                            </th>
                            <td>
                              {typeOfProfile[companyData[0]?.type_of_profile ]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                             Type of Account:
                            </th>
                            <td>
                              {typeOfAccount[companyData[0]?.type_of_account ]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Nature of Account:
                            </th>
                            <td>
                              {natureOfAccount[companyData[0]?.nature_of_account ]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Anticipated Volume:
                            </th>
                            <td>
                              {anticipateVolume[companyData[0]?.anticipated_volume  ]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Source of Funds:
                            </th>
                            <td>
                              {sourceOfFunds[companyData[0]?.source_of_funds  ]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Purpose And Intended Nature Of The Business Relationship:
                            </th>
                            <td>
                              {[companyData[0]?.purpose_and_intended_nature_of_business  ]}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              No. of Employees:
                            </th>
                            <td>
                              {employeeMap[companyData[0]?.no_of_employees]}
                            </td>
                          </tr>
                          {companyData[0]?.regulatory_body? 
                          <tr>
                            <th scope="row" className="fw-bold">
                            Regulatory Body or Listing Body:
                            </th>
                            <td>
                              {[companyData[0]?.regulatory_body]}
                            </td>
                          </tr>
                          :""}
                          {companyData[0]?.senior_management_names? 
                          <tr>
                            <th scope="row" className="fw-bold">
                            Names of Relevant Persons in Senior Management :
                            </th>
                            <td>
                              {[companyData[0]?.senior_management_names    ]}
                            </td>
                          </tr>
                          :""}

                          {companyData[0]?.external_auditor_name? 
                          <tr>
                            <th scope="row" className="fw-bold">
                            Name of External Auditor:
                            </th>
                            <td>
                              {[companyData[0]?.external_auditor_name]}
                            </td>
                          </tr>
                            :""}
                         
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h4
                        className="card-title fw-bold"
                        style={{ color: "#776ad8" }}
                      >
                        Contact Info
                      </h4>
                    </div>
                    <div className="card-body">
                      <Table striped bordered hover>
                        <tbody>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Address(1):
                            </th>
                            <td>{companyData[0]?.address1}</td>
                          </tr>
                          {companyData[0]?.address2 ?
                          <tr>
                            <th scope="row" className="fw-bold">
                              Address(2){" "}
                              <small className="text-muted">(Optional)</small>:
                            </th>
                            <td>{companyData[0]?.address2}</td>
                          </tr>
                          :""}
                          <tr>
                            <th scope="row" className="fw-bold">
                              City:
                            </th>
                            <td>{companyData[0]?.city}</td>
                          </tr>
                          {companyData[0]?.pobox ?
                          <tr>
                            <th scope="row" className="fw-bold">
                              Pobox:
                            </th>
                            <td>{companyData[0]?.pobox}</td>
                          </tr>
                          : ""}
                          <tr>
                            <th scope="row" className="fw-bold">
                              Country:
                            </th>
                            <td>{getCountryName(companyData[0]?.country)}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Telephone:
                            </th>
                            <td>{companyData[0]?.telephone}</td>
                          </tr>
                          {companyData[0]?.fax ?
                          <tr>
                            <th scope="row" className="fw-bold">
                              Fax{" "}
                              <small className="text-muted">(Optional)</small>:
                            </th>
                            <td>{companyData[0]?.fax}</td>
                          </tr>
                          : ""}
                          <tr>
                            <th scope="row" className="fw-bold">
                              E-Mail:
                            </th>
                            <td>{companyData[0]?.email}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Website:
                            </th>
                            <td>{companyData[0]?.website}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h4
                        className="card-title fw-bold"
                        style={{ color: "#776ad8" }}
                      >
                        KYC Documents
                      </h4>
                      <div className="text-muted">
                        <small>
                          The file size must be under 10 MB and only PDF format
                          is accepted.
                        </small>
                      </div>
                    </div>
                    <div className="card-body">
                      <Table striped bordered hover>
                        <tbody>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Commercial Registration:
                            </th>
                            <td>
                              {companyData[0]?.commercial_registration} &nbsp;
                              {companyData[0]?.commercial_registration && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-4"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.commercial_registration
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              VAT Registration Certificate:
                            </th>
                            <td>
                              {companyData[0]?.vat_registration} &nbsp;
                              {companyData[0]?.vat_registration && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.vat_registration
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                              Company Registration Extract:
                            </th>
                            <td>
                              {companyData[0]?.company_registration} &nbsp;
                              {companyData[0]?.company_registration && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.company_registration
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          {companyData[0]?.authorized_signatory_proof ?
                          <tr>
                            <th scope="row" className="fw-bold">
                            Identification documentation of the Authorised Signatory:
                            </th>
                            <td>
                              {companyData[0]?.authorized_signatory_proof } &nbsp;
                              {companyData[0]?.authorized_signatory_proof  && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.authorized_signatory_proof 
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          :""}
                          <tr>
                            <th scope="row" className="fw-bold">
                            Memorandum of Association:
                            </th>
                            <td>
                              {companyData[0]?.memorandum_of_association  } &nbsp;
                              {companyData[0]?.memorandum_of_association   && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.memorandum_of_association  
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Articles of Association:
                            </th>
                            <td>
                              {companyData[0]?.articles_of_association  } &nbsp;
                              {companyData[0]?.articles_of_association   && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.articles_of_association  
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Partnership Agreement:
                            </th>
                            <td>
                              {companyData[0]?.partnership_agreement   } &nbsp;
                              {companyData[0]?.partnership_agreement    && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.partnership_agreement   
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          {companyData[0]?.board_resolution ?
                          <tr>
                            <th scope="row" className="fw-bold">
                            Board Resolution:
                            </th>
                            <td>
                              {companyData[0]?.board_resolution    } &nbsp;
                              {companyData[0]?.board_resolution     && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.board_resolution    
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          :""}
                          <tr>
                            <th scope="row" className="fw-bold">
                            List of Authorized Signatories:
                            </th>
                            <td>
                              {companyData[0]?.list_of_authorized_signatories } &nbsp;
                              {companyData[0]?.list_of_authorized_signatories && (
                                <span
                                  hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.list_of_authorized_signatories     
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" className="fw-bold">
                            Latest Final Report and Accounts:
                            </th>
                            <td>
                              {companyData[0]?.latest_final_report_and_accounts } &nbsp;
                              {companyData[0]?.latest_final_report_and_accounts && (
                                <span
                                   hidden ={isReadOnly}
                                  className="badge badge-success ml-2"
                                  style={{
                                    backgroundColor: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDownload(
                                      companyData[0]?.latest_final_report_and_accounts     
                                    )
                                  }
                                >
                                  Download
                                </span>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="row justify-content-center">
                <div className="col-lg-12">
                <div className="card">
  <div className="card-header">
    <h4 className="card-title fw-bold" style={{ color: "#776ad8" }}>
      Declarations
    </h4>
  </div>
  <div className="card-body">
    {/* Declaration and Signature Section */}
    <div className="declaration-signature">
      {companyData[0]?.acting_on_my_behalf ?
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="acting_on_my_behalf"
          name="acting_on_my_behalf"
          checked={ companyData[0]?.acting_on_my_behalf}
        />
        <label className="form-check-label" htmlFor="acting_on_my_behalf">
          I/We hereby confirm that I/we are acting and would, in future will
          also be acting on my/our behalf for the purpose of transactions,
          new accounts or providing any further information required by Blue
          Aster Capital BSC ©.
        </label>
      </div>
      :""}
        {companyData[0]?.acting_on_behalf_of ?
      <div className="form-check d-flex align-items-center">
        <input
          className="form-check-input"
          type="checkbox"
          id="acting_on_behalf_of"
          name="acting_on_behalf_of"
         checked={companyData[0]?.acting_on_behalf_of}
        />
        <label className="form-check-label ms-2" htmlFor="acting_on_behalf_of">
          I/We hereby confirm that I/we are acting on behalf of
        </label> &nbsp;
        {companyData[0]?.acting_on_behalf_name}
      </div>
      :""}
      <div className="form-check">
      <input
          className="form-check-input"
          type="checkbox"
          id="information_true"
          name="information_true"
          checked={companyData[0]?.information_true}
        />
        <label className="form-check-label" htmlFor="information_true">
          I/We hereby confirm the information provided above is true, accurate
          and complete. Subject to applicable local laws, I/we hereby consent
          for Blue Aster Capital BSC © or any of its affiliates to share our
          information with domestic or overseas regulators or tax authorities
          where necessary.
        </label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="notify_on_change"
          name="notify_on_change"
          checked={companyData[0]?.notify_on_change}
        />
        <label className="form-check-label" htmlFor="notify_on_change">
          I/We agree and undertake to notify Blue Aster Capital BSC © within
          30 calendar days if there is a change in any information which I/we
          have provided.
        </label>
      </div>
      <div className="form-group mt-3">
        <label htmlFor="name " className="fw-bold ms-2">Name / Authorised Signatory Name:</label> {companyData[0]?.signatory_name}
      </div>
      {companyData[0]?.digital_signature ?
      <div className="form-group">
        <label htmlFor="signature" className="fw-bold ms-2">Digital Signature:</label><br />
        <div
          className="border rounded shadow-sm p-2 bg-light"
          style={{ display: 'inline-block', width: '300px', height: '200px' }}
        >
        <img src={signatureURL} alt="Digital Signature" style={{ maxWidth: '100%', height: 'auto' }} />

        </div> 
      </div>
      :""}
      <div className="form-group">
        <label htmlFor="date" className="fw-bold ms-2">Declaration Date:</label> {declarationDate}
        
      </div>
    </div>

    
  </div>
</div>

                </div>
              </div>

            </form>
            <a
              ref={downloadLinkRef}
              style={{ display: "none" }}
              href={() => false}
            ></a>
          </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnBoarding;
